import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { isMobile } from "react-device-detect";

import "react-toastify/dist/ReactToastify.css";
import "./styles/Font.css";
import "./index.css";
import "./styles/Game.css";
import "./styles/Winner.css";
import "./styles/Looser.css";
import "./styles/GameEnded.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
    <ToastContainer
      position={isMobile ? "top-center" : "bottom-right"}
      autoClose={isMobile ? 1000 : 4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
